import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import authService from '../services/authService';
import { useTranslation } from 'react-i18next';
import './ResetPassword.css';

const ResetPassword = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [token, setToken] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirmation, setPasswordConfirmation] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    const emailParam = searchParams.get('email');
    const tokenParam = searchParams.get('token');
    
    if (emailParam) setEmail(emailParam);
    if (tokenParam) setToken(tokenParam);
    
    if (!emailParam || !tokenParam) {
      setError(t('reset_password.invalid_link', 'Link inválido. Por favor, solicite um novo link de recuperação.'));
    }
  }, [searchParams]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password !== passwordConfirmation) {
      setError(t('reset_password.passwords_dont_match', 'As senhas não coincidem'));
      return;
    }

    if (password.length < 8) {
      setError(t('reset_password.min_password_length', 'A senha deve ter no mínimo 8 caracteres'));
      return;
    }

    setLoading(true);

    try {
      await authService.resetPassword(email, token, password, passwordConfirmation);
      setSuccess(true);
      setTimeout(() => {
        navigate('/login');
      }, 3000);
    } catch (err) {
      setError(err.response?.data?.error || 'Erro ao redefinir senha');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-logo">
          <div className="logo-circles">
            <span className="circle circle-1"></span>
            <span className="circle circle-2"></span>
            <span className="circle circle-3"></span>
          </div>
          <div className="logo-text">
            <div className="logo-title">Easy</div>
            <div className="logo-subtitle">Sistema de Gerenciamento</div>
          </div>
        </div>
        <h2 className="login-title">{t('reset_password.title', 'Redefinir Senha')}</h2>
        
        {success ? (
          <div className="success-message">
            <p>{t('reset_password.success', 'Senha redefinida com sucesso!')}</p>
            <p className="success-note">{t('reset_password.redirecting', 'Você será redirecionado para o login em instantes...')}</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="email">Email:</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="seu@email.com"
                disabled={loading || !!searchParams.get('email')}
              />
            </div>
            <div className="form-group">
              <label htmlFor="password">{t('reset_password.new_password', 'Nova Senha')}:</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder="••••••••"
                disabled={loading}
                minLength="8"
              />
              <small>{t('reset_password.min_chars', 'Mínimo de 8 caracteres')}</small>
            </div>
            <div className="form-group">
              <label htmlFor="passwordConfirmation">{t('reset_password.confirm_password', 'Confirmar Senha')}:</label>
              <input
                type="password"
                id="passwordConfirmation"
                value={passwordConfirmation}
                onChange={(e) => setPasswordConfirmation(e.target.value)}
                required
                placeholder="••••••••"
                disabled={loading}
                minLength="8"
              />
            </div>
            {error && <div className="error">{error}</div>}
            <button type="submit" className="btn btn-primary" disabled={loading || !token || !email}>
              {loading ? t('reset_password.resetting', 'Redefinindo...') : t('reset_password.title', 'Redefinir Senha')}
            </button>
            <div className="forgot-password-link">
              <button
                type="button"
                onClick={() => navigate('/login')}
                className="btn-link"
                disabled={loading}
              >
                {t('reset_password.back_to_login', 'Voltar para o login')}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default ResetPassword;

